// src/services/api.js - PERFECTLY STRUCTURED Nigerian Food Categories
const menuCategories = [
  {
    id: 'rice-boxes',
    name: 'Rice Boxes',
    description: 'Jollof, Fried Rice, Coconut Rice varieties',
    image: '/images/categories/Rice Boxes/jollof-rice.jpg',
    icon: '🍚'
  },
  {
    id: 'soup',
    name: 'Nigerian Soups',
    description: 'Egusi, Pepper Soup, Okra, Bitter Leaf, Oha soup, White soup, Edikang Ikong, Gbegiri, Ewedu',
    image: '/images/categories/soup/Egusi.jpeg',
    icon: '🍲'
  },
  {
    id: 'swallow',
    name: 'Swallow',
    description: 'Pounded Yam, Eba, Fufu, Amala, Semo, Starch, Wheat',
    image: '/images/categories/Swallow/amala.jpeg',
    icon: '🍞'
  },
  {
    id: 'pasta',
    name: 'Pasta',
    description: 'Alfredo, Bolognese, Pesto varieties, Roasted Tomato sauce, Tomato chicken pasta',
    image: '/images/categories/Pasta/alfredopasta.webp',
    icon: '🍝'
  },
  {
    id: 'drinks',
    name: 'Drinks',
    description: 'Zobo, Palm Wine, Fresh Juices, Soft Drinks, Coca-Cola, Sprite, water, Hennessy, Campari, Caramel Iced Tea, Martell Vsop',
    image: '/images/categories/Drinks/water.jpeg',
    icon: '🍹'
  },
  {
    id: 'pastries',
    name: 'Pastries',
    description: 'Meat Pie, Sausage Roll, Chicken Pie, Banana Bread (Nut Mix), Cupcakes, doughnuts, sausage roll, Tortilla wrap (Beef)',
    image: '/images/categories/pastries/images.jpeg',
    icon: '🥧'
  },
  {
    id: 'ice-cream',
    name: 'Ice Cream',
    description: 'Local and international ice cream flavors',
    image: '/images/categories/Ice cream/ice-cream-background.jpg',
    icon: '🍨'
  },
  {
    id: 'vegan',
    name: 'Vegan',
    description: 'Plant-based Nigerian dishes',
    image: '/images/categories/Vegan-meal-images/RoastedTeriyakiVe.jpg',
    icon: '🌱'
  },
  {
    id: 'vegetarian',
    name: 'Vegetarian',
    description: 'Vegetarian-friendly options',
    image: '/images/categories/vegetarian-images/stir-fried veggies.jpg',
    icon: '🥗'
  },
  {
    id: 'gluten-free',
    name: 'Gluten-Free',
    description: 'Safe options for gluten sensitivity',
    image: '/images/categories/Gluten-free-images/Gluten-free banner.avif',
    icon: '🌾'
  },
  {
    id: 'breakfast',
    name: 'Breakfast',
    description: 'Start your day with authentic Nigerian breakfast',
    image: '/images/categories/Breakfast-images/akara and pap.jpeg',
    icon: '🍳'
  },
  {
    id: 'lunch',
    name: 'Lunch Specials',
    description: 'Hearty midday meals and chicken varieties',
    image: '/images/categories/chicken Fest/Buttermilk-fried-chicken.jpeg',
    icon: '🥘'
  }
];

const mockMenuItems = [
  // RICE BOXES 🍚
  {
    _id: '1',
    name: 'Jollof Rice Special',
    description: 'The crown jewel of Nigerian cuisine! Perfectly seasoned rice with rich tomato base.',
    price: 3500,
    category: 'rice-boxes',
    image: '/images/categories/Rice Boxes/jollof-rice.jpg',
    averageRating: 4.9,
    isAvailable: true,
    preparationTime: 30,
    spiceLevel: 'Medium',
    isPopular: true,
    ingredients: ['Nigerian rice', 'Fresh tomatoes', 'Bell peppers', 'Onions', 'Nigerian spices', 'Protein choice']
  },
  {
    _id: '2',
    name: 'Fried Rice Deluxe',
    description: 'Colorful fried rice with mixed vegetables and Nigerian spices.',
    price: 3200,
    category: 'rice-boxes',
    image: '/images/categories/Rice Boxes/fried-rice.jpg',
    averageRating: 4.7,
    isAvailable: true,
    preparationTime: 25,
    spiceLevel: 'Mild',
    ingredients: ['Parboiled rice', 'Mixed vegetables', 'Eggs', 'Soy sauce', 'Nigerian curry', 'Green beans']
  },
  {
    _id: '3',
    name: 'Coconut Rice Supreme',
    description: 'Fragrant rice cooked in coconut milk with Nigerian spices, vegetables, and aromatic herbs.',
    price: 3000,
    category: 'rice-boxes',
    image: '/images/coconut-rice.jpg',
    averageRating: 4.3,
    isAvailable: true,
    preparationTime: 25,
    spiceLevel: 'Mild',
    ingredients: ['Rice', 'Coconut milk', 'Mixed vegetables', 'Nigerian curry', 'Bay leaves']
  },
  
  // SOUPS 🍲
  {
    _id: '4',
    name: 'Goat Meat Pepper Soup',
    description: 'Spicy and aromatic traditional pepper soup with tender goat meat.',
    price: 4500,
    category: 'soup',
    image: '/images/categories/Dinner-image/Black-pepper soup.webp',
    averageRating: 4.8,
    isAvailable: true,
    preparationTime: 45,
    spiceLevel: 'Hot',
    isPopular: true,
    ingredients: ['Fresh goat meat', 'Pepper soup spice', 'Uziza leaves', 'Ginger', 'Garlic', 'Onions']
  },
  {
    _id: '5',
    name: 'CatFish Pepper Soup',
    description: 'Traditional Nigerian catfish pepper soup with aromatic spices.',
    price: 3800,
    category: 'soup',
    image: '/images/categories/soup/pepper-soup2.jpeg',
    averageRating: 4.5,
    isAvailable: true,
    preparationTime: 35,
    spiceLevel: 'Very Hot',
    ingredients: ['Fresh catfish', 'Pepper soup spice', 'Scent leaves', 'Ginger', 'Garlic']
  },
  {
    _id: '6',
    name: 'Black Pepper Soup',
    description: 'Spicy and aromatic traditional and medicinal black soup.',
    price: 4500,
    category: 'soup',
    image: '/images/categories/Dinner-image/Black-pepper soup.webp',
    averageRating: 4.8,
    isAvailable: true,
    preparationTime: 45,
    spiceLevel: 'Hot',
    isPopular: true,
    ingredients: ['Fresh meat', 'Black pepper soup spice', 'Uziza leaves', 'Ginger', 'Garlic', 'Onions']
  },

  // PASTRIES 🥧
  {
    _id: '7',
    name: 'Nigerian Meat Pie',
    description: 'Flaky pastry filled with seasoned minced meat and vegetables.',
    price: 1200,
    category: 'pastries',
    image: '/images/categories/pastries/meat-pie.jpg',
    averageRating: 4.3,
    isAvailable: true,
    preparationTime: 10,
    spiceLevel: 'Mild',
    ingredients: ['Pastry flour', 'Minced meat', 'Potatoes', 'Carrots', 'Nigerian spices']
  },
  {
    _id: '8',
    name: 'Crispy Chin Chin',
    description: 'Crunchy, sweet fried snack perfect for any time of day. Made with traditional recipe.',
    price: 1500,
    category: 'pastries',
    image: '/images/chin-chin.jpg',
    averageRating: 4.1,
    isAvailable: true,
    preparationTime: 5,
    spiceLevel: 'None',
    ingredients: ['Flour', 'Sugar', 'Butter', 'Eggs', 'Nutmeg']
  },
  {
    _id: '9',
    name: 'Tortilla Wrap (Beef)',
    description: 'Delicious tortilla wrap filled with spiced beef and fresh vegetables.',
    price: 4500,
    category: 'pastries',
    image: '/images/categories/pastries/Tortilla wrap(beef).jpeg',
    averageRating: 4.4,
    isAvailable: true,
    preparationTime: 15,
    spiceLevel: 'Mild',
    ingredients: ['Flour tortilla', 'Spiced beef', 'Butter', 'Sauce', 'Vegetables', 'Cheese']
  },
  {
    _id: '10',
    name: 'Tortilla Wrap (Chicken)',
    description: 'Delicious tortilla wrap filled with spiced chicken and fresh vegetables.',
    price: 4500,
    category: 'pastries',
    image: '/images/categories/pastries/Tortilla wrap(chicken).jpeg',
    averageRating: 4.4,
    isAvailable: true,
    preparationTime: 15,
    spiceLevel: 'Mild',
    ingredients: ['Flour tortilla', 'Spiced chicken', 'Butter', 'Sauce', 'Vegetables', 'Cheese']
  },
  {
    _id: '11',
    name: 'Banana Bread (Nut Mix)',
    description: 'Delicious banana bread with a mix of nuts for added crunch.',
    price: 6500,
    category: 'pastries',
    image: '/images/categories/pastries/Banana bread (nut mix).jpeg',
    averageRating: 4.6,
    isAvailable: true,
    preparationTime: 20,
    spiceLevel: 'None',
    ingredients: ['Flour', 'Sugar', 'Butter', 'Eggs', 'Nutmeg', 'Mixed nuts', 'Bananas']
  },
  {
    _id: '12',
    name: 'Cupcakes',
    description: 'Deliciously soft and fluffy cupcakes with a variety of flavors.',
    price: 2500,
    category: 'pastries',
    image: '/images/categories/pastries/Cupcakes.webp',
    averageRating: 4.3,
    isAvailable: true,
    preparationTime: 10,
    spiceLevel: 'None',
    ingredients: ['Flour', 'Sugar', 'Butter', 'Eggs', 'Vanilla extract', 'Frosting']
  },

  // DRINKS 🍹
  {
    _id: '13',
    name: 'Fresh Zobo Drink',
    description: 'Refreshing hibiscus drink with ginger, cucumber, and fruits.',
    price: 1500,
    category: 'drinks',
    image: '/images/zobo.jpg',
    averageRating: 4.4,
    isAvailable: true,
    preparationTime: 5,
    spiceLevel: 'None',
    ingredients: ['Hibiscus leaves', 'Ginger', 'Cucumber', 'Pineapple', 'Watermelon', 'Lime']
  },
  {
    _id: '14',
    name: 'Pure Water',
    description: 'Pure and refreshing bottled water.',
    price: 500,
    category: 'drinks',
    image: '/images/categories/Drinks/water.jpeg',
    averageRating: 5.0,
    isAvailable: true,
    preparationTime: 1,
    spiceLevel: 'None',
    ingredients: ['Pure water']
  },
  {
    _id: '15',
    name: 'Campari Wine',
    description: 'Refreshing Italian bitter aperitif wine.',
    price: 11500,
    category: 'drinks',
    image: '/images/categories/Drinks/campari.webp',
    averageRating: 4.2,
    isAvailable: true,
    preparationTime: 2,
    spiceLevel: 'None',
    ingredients: ['Campari', 'Herbs', 'Fruit']
  },
  {
    _id: '16',
    name: 'Hennessy Cognac',
    description: 'Premium French cognac with a rich and smooth flavor.',
    price: 25000,
    category: 'drinks',
    image: '/images/categories/Drinks/Hennessy Cognac.jpg',
    averageRating: 4.8,
    isAvailable: true,
    preparationTime: 2,
    spiceLevel: 'None',
    ingredients: ['Premium cognac', 'Aged in oak barrels']
  },
  {
    _id: '17',
    name: 'Traditional Palm Wine',
    description: 'Refreshing traditional palm wine with authentic Nigerian taste.',
    price: 1500,
    category: 'drinks',
    image: '/images/categories/Drinks/Palm-wine.jpg',
    averageRating: 4.4,
    isAvailable: true,
    preparationTime: 2,
    spiceLevel: 'None',
    ingredients: ['Fresh palm wine', 'Natural fermentation']
  },

  // VEGAN 🌱
  {
    _id: '18',
    name: 'Avocado Toast',
    description: 'Delicious toast topped with fresh avocado and spices.',
    price: 3800,
    category: 'vegan',
    image: '/images/categories/Vegan/avocado-toast-1.jpg',
    averageRating: 4.2,
    isAvailable: true,
    preparationTime: 10,
    spiceLevel: 'Mild',
    ingredients: ['Whole grain bread', 'Fresh avocado', 'Sea salt', 'Black pepper', 'Olive oil']
  },
  {
    _id: '19',
    name: 'High Protein Delicacy',
    description: 'Nutritious delicacy rich in plant-based protein and vitamins.',
    price: 7800,
    category: 'vegan',
    image: '/images/categories/Vegan/high-protein.jpg',
    averageRating: 4.5,
    isAvailable: true,
    preparationTime: 25,
    spiceLevel: 'Mild',
    ingredients: ['Quinoa', 'Black beans', 'Corn', 'Avocado', 'Lime', 'Cilantro']
  },
  {
    _id: '20',
    name: 'Ponzu Tofu Poke',
    description: 'Delicious tofu marinated in ponzu sauce, served with fresh vegetables.',
    price: 3800,
    category: 'vegan',
    image: '/images/categories/Vegan/Ponzu-tofu-poke.jpg',
    averageRating: 4.3,
    isAvailable: true,
    preparationTime: 15,
    spiceLevel: 'Mild',
    ingredients: ['Organic tofu', 'Ponzu sauce', 'Fresh vegetables', 'Sesame seeds']
  },

  // PASTA 🍝
  {
    _id: '21',
    name: 'Creamy Alfredo Pasta',
    description: 'Rich and creamy Alfredo pasta with parmesan cheese and herbs.',
    price: 8000,
    category: 'pasta',
    image: '/images/categories/Pasta/alfredopasta.webp',
    averageRating: 4.6,
    isAvailable: true,
    preparationTime: 20,
    spiceLevel: 'Mild',
    ingredients: ['Fettuccine pasta', 'Alfredo sauce', 'Parmesan cheese', 'Garlic', 'Butter', 'Herbs']
  },

  // LUNCH SPECIALS 🥘
  {
    _id: '22',
    name: 'Buttermilk Fried Chicken',
    description: 'Crispy buttermilk fried chicken served with perfectly seasoned sides - a customer favorite!',
    price: 4200,
    category: 'lunch',
    image: '/images/categories/chicken Fest/Buttermilk-fried-chicken.jpeg',
    averageRating: 4.6,
    isAvailable: true,
    preparationTime: 25,
    spiceLevel: 'Medium',
    isPopular: true,
    ingredients: ['Fresh chicken', 'Buttermilk', 'Nigerian spices', 'Flour', 'Vegetable oil']
  },

  // BREAKFAST 🍳
  {
    _id: '23',
    name: 'Akara and Pap',
    description: 'Traditional Nigerian breakfast with bean cakes (Akara) and corn pudding (Pap) - start your day right!',
    price: 2500,
    category: 'breakfast',
    image: '/images/categories/Breakfast-images/akara and pap.jpeg',
    averageRating: 4.5,
    isAvailable: true,
    preparationTime: 20,
    spiceLevel: 'Mild',
    ingredients: ['Beans', 'Pepper', 'Onions', 'Palm oil', 'Cornmeal', 'Water']
  }
];

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function loginUser(email, password) {
  const res = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error('Login failed');
  return await res.json(); // Should return user info + token
}

export async function registerUser(data) {
  const res = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Registration failed');
  return res.json();
}

export const apiService = {
  getMenuItems: () => Promise.resolve({ data: mockMenuItems }),
  getCategories: () => Promise.resolve({ data: menuCategories }),
  getMenuByCategory: (category) => Promise.resolve({ 
    data: mockMenuItems.filter(item => item.category === category) 
  }),
  login: (credentials) => Promise.resolve({ 
    data: { 
      token: 'mock-jwt-token', 
      user: { 
        name: credentials.email.split('@')[0], 
        email: credentials.email,
        id: 'user-123'
      } 
    } 
  }),
  register: (userData) => Promise.resolve({ 
    data: { 
      token: 'mock-jwt-token', 
      user: { 
        name: userData.name,
        email: userData.email,
        phone: userData.phone,
        id: 'user-123'
      } 
    } 
  })
};

export { menuCategories };
export default apiService;